import { API } from "@/lib/api";

let trackingConfig = null;

export async function loadTrackingConfig() {
  if (trackingConfig) return trackingConfig;
  try {
    const res = await fetch(`${API}/public/config`);
    trackingConfig = await res.json();
  } catch {
    trackingConfig = {};
  }
  return trackingConfig;
}

export function trackEvent(name, params = {}) {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
      const cfg = trackingConfig || {};
      if (cfg.google_ads_id && cfg.google_ads_label &&
          ["book_consultation_click", "checklist_download", "quote_form_submit"].includes(name)) {
        window.gtag("event", "conversion", {
          send_to: `${cfg.google_ads_id}/${cfg.google_ads_label}`,
          event_name: name,
        });
      }
    }
    if (typeof window.fbq === "function") {
      window.fbq("trackCustom", name, params);
    }
  } catch {
    /* analytics must never break the page */
  }
}
